// eslint-disable-next-line import/named
import { captureException } from "@sentry/react";

import {
	ILogEntryCallback,
	ILogger,
	ILogMessage,
	IProcessLogMessage
} from "../../web-shared-components/helpers/logger/ILogger";

/**
 * SentryLogger sends logs to Sentry
 */
export class SentryLogger implements ILogEntryCallback {
	// Instance of this class to use as singleton.
	private static instance: SentryLogger;
	// Interface to main logger (theLogger)
	private logger: ILogger;
	/**
	 * Private constructor because of singleton
	 *
	 * @param logger - interface to theLogger
	 */
	private constructor(logger: ILogger) {
		this.logger = logger;
	}

	/**
	 * Singleton
	 *
	 * @param logger - interface to theLogger
	 * @returns instance of this class
	 */
	public static getInstance(logger: ILogger): SentryLogger {
		if (!SentryLogger.instance) SentryLogger.instance = new SentryLogger(logger);
		return SentryLogger.instance;
	}

	/**
	 * Gets notified by the logger
	 *
	 * @param logMessage - log entry to log
	 * @returns - undefined as we do want other callbacks to act on the log message
	 */
	public onLogMessage(logMessage: ILogMessage): IProcessLogMessage | undefined {
		// Implement Sentry logging logic here
		if (logMessage.level === "error") {
			// Send error to Sentry
			if (logMessage.error instanceof Error) captureException(logMessage.error);
			else {
				const errorMsg = logMessage.message + "-" + logMessage.method + "-" + JSON.stringify(logMessage.meta);
				const newError = new Error(errorMsg);

				captureException(newError);
			}
		}
		return undefined;
	}
}
